import { makeStyles } from '@material-ui/core';

export const listStyles = makeStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		maxWidth: '60rem',
		width: '100%',
		margin: 'auto',
	},
	listItem: {
		width: '100%',
	},
});
